import { reachMetrikaGoal } from '@/utils/metrikaGoals'

export const METRIKA_GOAL_BILLING_PURCHASE = 'billing_purchase'

const PURCHASE_SENT_PREFIX = 'metrika_purchase_sent_'
const ECOMMERCE_BRAND = 'AI-Tenders'
const CURRENCY_CODE = 'RUB'

function ensureDataLayer() {
  if (typeof window === 'undefined') return null
  window.dataLayer = window.dataLayer || []
  return window.dataLayer
}

function normalizeProduct({
  id,
  name,
  price,
  quantity = 1,
  category = '',
  brand = ECOMMERCE_BRAND,
}) {
  const product = {
    id: String(id || name || 'item'),
    name: String(name || id || 'Товар'),
    brand,
    quantity: Number(quantity) || 1,
  }
  const numericPrice = Number(price)
  if (Number.isFinite(numericPrice) && numericPrice > 0) {
    product.price = numericPrice
  }
  if (category) product.category = String(category)
  return product
}

export function pushEcommerceAdd(productInput) {
  const dataLayer = ensureDataLayer()
  if (!dataLayer) return
  const product = normalizeProduct(productInput)
  dataLayer.push({
    ecommerce: {
      currencyCode: CURRENCY_CODE,
      add: {
        products: [product],
      },
    },
  })
}

function purchaseAlreadySent(transactionId) {
  if (!transactionId || typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(`${PURCHASE_SENT_PREFIX}${transactionId}`) === '1'
}

function markPurchaseSent(transactionId) {
  if (!transactionId || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(`${PURCHASE_SENT_PREFIX}${transactionId}`, '1')
  } catch {
    /* ignore */
  }
}

/**
 * @param {object} params
 * @param {string} params.transactionId
 * @param {number} [params.revenue]
 * @param {Array<object>} params.products
 */
export function pushEcommercePurchase({ transactionId, revenue, products = [] }) {
  const id = String(transactionId || '').trim()
  if (!id || purchaseAlreadySent(id)) return false

  const dataLayer = ensureDataLayer()
  if (!dataLayer) return false

  const normalizedProducts = (products.length ? products : [{ id: 'payment', name: 'Оплата' }]).map(
    (p) => normalizeProduct(p),
  )

  const actionField = { id }
  const numericRevenue = Number(revenue)
  if (Number.isFinite(numericRevenue) && numericRevenue > 0) {
    actionField.revenue = numericRevenue
  }

  dataLayer.push({
    ecommerce: {
      currencyCode: CURRENCY_CODE,
      purchase: {
        actionField,
        products: normalizedProducts,
      },
    },
  })

  markPurchaseSent(id)
  reachMetrikaGoal(METRIKA_GOAL_BILLING_PURCHASE)
  return true
}

/** Собрать product[] из checkout-контекста TheCabinet. */
export function productsFromCheckoutContext(ctx) {
  if (!ctx) return []
  if (ctx.product_id || ctx.product_name) {
    return [
      {
        id: ctx.product_id,
        name: ctx.product_name,
        price: ctx.product_price,
        category: ctx.product_category,
        quantity: 1,
      },
    ]
  }
  return []
}

export function trackPurchaseFromPayment(ctx, payment) {
  if (!payment || payment.status !== 'succeeded') return false

  const transactionId =
    payment.yookassa_payment_id
    || (ctx?.billing_payment_id != null ? `bp_${ctx.billing_payment_id}` : null)
    || (payment.id != null ? `pay_${payment.id}` : null)

  if (!transactionId) return false

  const products = productsFromCheckoutContext(ctx)
  if (!products.length && payment.description) {
    products.push({
      id: ctx?.kind || 'payment',
      name: String(payment.description),
      price: payment.amount,
      category: ctx?.product_category || (ctx?.kind === 'topup' ? 'TopUp' : 'Subscription'),
    })
  }

  return pushEcommercePurchase({
    transactionId,
    revenue: payment.amount,
    products,
  })
}
